import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/empty.png'


const _withScopeId = n => (_pushScopeId("data-v-7f8957d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"padding":"0.7rem"} }
const _hoisted_2 = { class: "cls-flex border-btm" }
const _hoisted_3 = { class: "item-uesr" }
const _hoisted_4 = { class: "cls-con" }
const _hoisted_5 = {
  class: "desc",
  style: {"padding-top":"0.2rem"}
}
const _hoisted_6 = { class: "desc" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "注册时间：", -1))
const _hoisted_8 = { style: {"color":"#333"} }
const _hoisted_9 = {
  class: "desc",
  style: {"padding-top":"0.1rem"}
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "超级会员时间：", -1))
const _hoisted_11 = { style: {"color":"#333"} }
const _hoisted_12 = {
  class: "desc",
  style: {"padding-top":"0.1rem"}
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "托管时间：", -1))
const _hoisted_14 = { style: {"color":"#333"} }
const _hoisted_15 = {
  class: "desc",
  style: {"padding-top":"0.1rem"}
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "到期时间：", -1))
const _hoisted_17 = { style: {"color":"#333"} }
const _hoisted_18 = {
  class: "desc",
  style: {"padding-top":"0.1rem"}
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "用户人数：", -1))
const _hoisted_20 = { style: {"color":"#333"} }
const _hoisted_21 = {
  class: "desc",
  style: {"padding-top":"0.1rem"}
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "会员人数：", -1))
const _hoisted_23 = { style: {"color":"#333"} }
const _hoisted_24 = { class: "cls-con" }
const _hoisted_25 = {
  class: "desc",
  style: {"padding-top":"0.1rem"}
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "超级会员人数：", -1))
const _hoisted_27 = { style: {"color":"#333"} }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = {
  key: 0,
  style: {"text-align":"center"}
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"width":"70vw","height":"auto"}
}, null, -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty-tip" }, "暂无托管超级会员 ", -1))
const _hoisted_32 = [
  _hoisted_30,
  _hoisted_31
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item.shareholderId,
        class: "white-radius",
        style: {"font-size":"0.9rem"}
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_van_image, {
            src: item.thumb,
            width: "2.5rem",
            height: "2.5rem",
            radius: "2rem"
          }, null, 8, ["src"]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", null, _toDisplayString(item.shareholderName), 1),
              _createElementVNode("div", null, _toDisplayString(item.source), 1)
            ]),
            _createElementVNode("div", _hoisted_5, " ID:" + _toDisplayString(item.shareholderId), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("span", _hoisted_8, _toDisplayString(item.createDate), 1)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("span", _hoisted_11, _toDisplayString(item.shareholderCreateDate), 1)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("span", _hoisted_14, _toDisplayString(item.shareholderJoinDate), 1)
        ]),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("span", _hoisted_17, _toDisplayString(item.expriceDate), 1)
        ]),
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _createElementVNode("span", _hoisted_20, _toDisplayString(item.membNum), 1)
        ]),
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          _createElementVNode("span", _hoisted_23, _toDisplayString(item.vipNum), 1)
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _hoisted_26,
            _createElementVNode("span", _hoisted_27, _toDisplayString(item.shareholderNum), 1)
          ]),
          _createElementVNode("div", {
            style: {"color":"#D8C14F"},
            onClick: ($event: any) => (_ctx.member_click(item))
          }, "客户列表 >", 8, _hoisted_28)
        ])
      ]))
    }), 128)),
    (!_ctx.list.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_29, _hoisted_32))
      : _createCommentVNode("", true)
  ]))
}